module.exports = __webpack_public_path__ + "img/image-loading.2ad0986c.gif";